import React, { useEffect, useRef, useState } from 'react';
import NavBar from '../_components/navbar';
import { connect, useDispatch } from "react-redux";
import { versaoSistemaAction } from '../_actions';
import { withRouter } from '../_helpers/withRouter';
import {
    Breadcrumb, BreadcrumbItem, Card, CardBody, CardHeader,
    Button, ButtonGroup, Container, Row, Col, FormGroup, Label, Input, Form
} from 'reactstrap';
import { uploadFile } from '../_services'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUndo, faCheck } from '@fortawesome/free-solid-svg-icons'
import Select from 'react-select';
import Swal from 'sweetalert2';
import JoditEditor from "jodit-react";

const VersaoSistemaEdit = (props, { placeholder }) => {

    const dispatch = useDispatch();
    const editor = useRef(null);
    const [content, setContent] = useState('');

    useEffect(() => {
        const { match: { params } } = props;
        const { dispatch } = props;

        if (params.id) {
            dispatch(versaoSistemaAction.getVersaoSistemaById(params.id, true));
        }

    }, []);

    const handleSelectChange = prop => event => {

        var event2 = {
            type: 'select',
            target: {
                value: event.value
            }
        };
        dispatch(versaoSistemaAction.onChangeProps(prop, event2));

    };

    const handleChange = prop => event => {
        dispatch(versaoSistemaAction.onChangeProps(prop, event));
    };


    const handleValidation = () => {

        var valid = true;
        var errors = '';

        if (props.versaoSistema.codigo === null || props.versaoSistema.codigo === '' || props.versaoSistema.codigo === 0) {
            valid = false;
            errors += '<li style="float:left;">Informe um código de versão!</li><br>';
        }

        if (props.versaoSistema.sistema === null || props.versaoSistema.sistema === '' || props.versaoSistema.sistema === 0) {
            valid = false;
            errors += '<li style="float:left;">Informe um sistema!</li><br>';
        }

        if (!valid) {

            Swal.fire({
                icon: 'warning',
                title: 'Erros de validação',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: left"><ul>' + errors + '</ul></div>'
            });

        }

        return valid;

    };

    const handleSubmit = event => {

        event.preventDefault();
        const { match: { params } } = props;

        if (handleValidation()) {

            let payload = {
                id: params.id,
                codigo: props.versaoSistema.codigo,
                sistema: props.versaoSistema.sistema
            }

            if (params.id) {
                dispatch(versaoSistemaAction.editVersaoSistemaInfo(params.id, payload));
            } else {
                dispatch(versaoSistemaAction.createVersaoSistema(payload));
            }

        }

    };

    const renderOptionsSistema = () => {
        var tipoData = [
            { value: '', name: 'SELECIONE...' },
            { value: 'financeiro', name: 'Financeiro' },
            { value: 'inseminadores', name: 'Inseminadores' },
            { value: 'zootecnico', name: 'Zootécnico' },
            { value: 'indicadores', name: 'Indicadores' }
        ];

        return tipoData.map((p, i) => {
            return (
                { value: p.value, label: p.name }
            );
        });
    };

    return (
        <div>
            <NavBar {...props} />
            <Container>
                <Card>
                    <CardHeader>
                        <Row>
                            <Col md={12}>
                                <Breadcrumb>
                                    <BreadcrumbItem><a href="/versoesSistemas">Lista de Versões do Sistema</a></BreadcrumbItem>
                                    <BreadcrumbItem active>Versão do Sistema {props.id}</BreadcrumbItem>
                                </Breadcrumb>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Form onSubmit={(event) => handleSubmit(event)}>
                            <Row>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label className="left" for="codigo_versao">Código da Versão</Label>
                                        <Input
                                            id="codigo"
                                            label="Código da Versão"
                                            type="text"
                                            value={props.versaoSistema.codigo || ''}
                                            maxLength={20}
                                            onChange={handleChange('codigo')}
                                        />
                                    </FormGroup>
                                </Col>

                                <Col md={4}>
                                    <FormGroup>
                                        <Label className="left" for="tipo">Sistema *</Label>
                                        <Select
                                            classNamePrefix="select"
                                            value={renderOptionsSistema().filter(option => option.value === (props.versaoSistema.sistema || ''))}
                                            placeholder="Selecione..."
                                            onChange={handleSelectChange('sistema')}
                                            isSearchable
                                            id="sistema"
                                            name="sistema"
                                            options={renderOptionsSistema()}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                <Col className="left" md="8" lg="6">
                                    <span>* Campos obrigatórios</span>
                                </Col>
                                <Col className="d-flex flex-row-reverse" md="4" lg="6">
                                    <ButtonGroup>
                                        <Button variant="contained" className="mr-1" color="secondary" component='a' href="/versoesSistemas">Voltar <FontAwesomeIcon icon={faUndo} /></Button>
                                        <Button variant="contained" className="mr-1" color="primary" type="submit">Salvar <FontAwesomeIcon icon={faCheck} /></Button>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </Form>
                    </CardBody>
                </Card>
            </Container>

            
        </div>
    );

}

const mapStateToProps = (state) => {
    return state;
}

const connectedVersaoSistemaEditPage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(VersaoSistemaEdit));
export { connectedVersaoSistemaEditPage as VersaoSistemaEdit };